import { auth } from '../../../services/firebaseConfig';
import { config } from '../../../config/config';

/**
 * Centralized analytics for monetization events.
 * Fires-and-forgets a POST to /monetization/events for every tracked event.
 * Falls back to console.warn on network failure so it never breaks the UI.
 */
export class AdAnalyticsService {
  constructor({ sessionId, userId } = {}) {
    this._sessionId = sessionId ?? null;
    this._userId = userId ?? null;
  }

  track(eventType, metadata = {}) {
    const event = {
      eventType,
      sessionId: this._sessionId,
      userId: this._userId,
      timestamp: Date.now(),
      ...metadata,
    };
    console.log('[AdAnalytics]', event);
    this._persist(event);
  }

  async _persist(event) {
    try {
      const user = auth.currentUser;
      if (!user) return; // anonymous/unauthenticated — skip
      const token = await user.getIdToken();

      await fetch(`${config.apiUrl}/monetization/events`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
          eventType:          event.eventType,
          sessionId:          event.sessionId ?? null,
          adMode:             event.mode ?? undefined,
          completedSongCount: event.completedSongCount ?? undefined,
          success:            event.success ?? undefined,
          error:              event.error ?? undefined,
        }),
      });
    } catch (err) {
      console.warn('[AdAnalytics] Failed to persist event:', err);
    }
  }
}

// Named event constants — use these everywhere instead of raw strings
export const AD_EVENTS = {
  SONG_COMPLETED: 'song_completed',
  AD_BREAK_DUE: 'ad_break_due',
  AD_BREAK_MODAL_SHOWN: 'ad_break_modal_shown',
  AD_BREAK_CONTINUE_CLICKED: 'ad_break_continue_clicked',
  AD_BREAK_LATER_CLICKED: 'ad_break_later_clicked',
  AD_TRIGGER_ATTEMPT: 'ad_trigger_attempt',
  AD_TRIGGER_SUCCESS: 'ad_trigger_success',
  AD_TRIGGER_FAILED: 'ad_trigger_failed',
  POPUP_BLOCKED: 'popup_blocked',
  SONG_COUNTER_RESET: 'song_counter_reset',
  PLAYLIST_RESUMED: 'playlist_resumed',
};
